export const FLIGHT_POS_LABEL = { PIC: 'PIC', FO: 'FO', FO_ADD: 'FO adicional', TCP: 'TCP (sin número)', TCP_ADD: 'TCP adicional' };
export const FICHA_LABEL = { captain: 'Capitán', first_officer: 'Primer Oficial', flight_attendant: 'TCP' };

export const posLabel = (p) => FLIGHT_POS_LABEL[p] || p || '';

// Posiciones permitidas en el vuelo según la ficha; los cruces de piloto solo en vuelo de instrucción
export function positionOptions(fichaPosition, training, cabinSlots) {
    if (fichaPosition === 'captain') return training ? ['PIC', 'FO'] : ['PIC'];
    if (fichaPosition === 'first_officer') return training ? ['FO', 'PIC', 'FO_ADD'] : ['FO'];
    if (fichaPosition === 'flight_attendant') return cabinSlots || [];
    return [];
}
